import React, { useRef, useState, useEffect } from 'react'
import styles from './StageDialog.module.css'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { shuffledArray } from '../../../../util/util'
import { saveLastScore } from '../../../../store/actions'
import BottomBar from '../components/BottomBar/BottomBar'
import Image from '../components/Image/Image'
import {
    getSoundDownloadUrl
} from '../components/Sound/Sound'

const Question = ({
    question,
    onClick,
    selected,
    good
}) => {
    return (
        <div
            className={styles.questionContainer}>
            <p className={styles.question}>{question.question}</p>
            <div className={styles.answersContainer}>
                <p
                    onClick={onClick ? () => onClick('True') : null}
                    className={styles.answerButton}
                    style={{
                        backgroundColor: selected === 'True' ? good ? good === 'True' ? '#26C281' : '#FF6464' : '#309CFF' : 'white',
                        color: selected === 'True' ? 'white' : 'black'
                    }}>True</p>
                <p
                    onClick={onClick ? () => onClick('False') : null}
                    className={styles.answerButton}
                    style={{
                        backgroundColor: selected === 'False' ? good ? good === 'True' ? '#26C281' : '#FF6464' : '#309CFF' : 'white',
                        color: selected === 'False' ? 'white' : 'black'
                    }}>False</p>
            </div>

        </div>
    )
}

const Chat = ({ chat, imagePath, playing }) => {
    return (
        <div className={styles.chatContainer} style={playing ? {backgroundColor: '#dddddd'} : {}}>
            <Image imagePath={imagePath} size={48} className={styles.chatImage}/>
            <div className={styles.chatTextContainer}>
                <p className={styles.chatName}>{chat.name}</p>
                <p className={styles.chatText}>{chat.text}</p>
            </div>
        </div>
    )
}

const StageDialog = ({
    data,
    onPageChange,
}) => {
    const history = useHistory()
    const dispatch = useDispatch()

    const [selected, setSelected] = useState(Array(data.questions.length).fill(null))
    const [enabledCheck, setEnabledCheck] = useState(false)
    const [isGood, setIsGood] = useState(Array(data.questions.length).fill(null))
    const [done, setDone] = useState(false)
    const [playingIndex, setPlayingIndex] = useState(-1)
    //const [au, setPlayingIndex] = useState(0)

    const score = useRef(0)
    const mediaPlayers = useRef(Array(data.chat.length).fill(new Audio()))
    const shuffledQuestions = useRef(shuffledArray(data.questions));

    const handleAnswerClick = (index, mode) => {
        const updatedSelected = selected.slice()
        updatedSelected[index] = mode
        setSelected(updatedSelected)
        const doneCount = updatedSelected.filter(e => e).length
        onPageChange(doneCount)

        if (doneCount === data.questions.length) {
            setEnabledCheck(true)
        }
    }

    const onCheck = () => {
        const updatedIsGood = isGood.slice();
        shuffledQuestions.current.map((question, index) => {
            if ((question.answer === true && selected[index] === 'True') ||
                (question.answer === false && selected[index] === 'False')) {
                updatedIsGood[index] = 'True'
                score.current += 10 / data.questions.length
            }
            else {
                updatedIsGood[index] = 'False'
            }
        })
        setDone(true);
        setIsGood(updatedIsGood)
    }

    const onFinish = () => {
        dispatch(saveLastScore(score.current))
        history.goBack();
    }

    useEffect(() => {
        if (playingIndex === -1) {
            setTimeout(() => {
                setPlayingIndex(i => i + 1)
            }, 1000);
        }
        else if (playingIndex < data.chat.length) playSound(playingIndex)
    }, [playingIndex])

    const playSound = (index) => {
        getSoundDownloadUrl(data.chat[index].sound_path).then((url) => {
            const audio = new Audio(url)
            audio.addEventListener('ended', onEndPlaySound)
            audio.play();
        })
    }

    const onEndPlaySound = () => {
        setPlayingIndex(i => i + 1)
    }

    return (
        <div className={styles.container}>
            <div className={styles.fullChatContainer}>
                {
                    data.chat.map((chat, index) => {
                        return (
                            <Chat 
                                playing={playingIndex === index}
                                chat={chat}
                                imagePath={data.images[chat.name]}/>
                        )
                    })
                }
            </div>
            <div className={styles.divider} />
            <div className={styles.questionsContainer}>
                {
                    shuffledQuestions.current.map((question, index) => {
                        return (
                            <Question
                                good={isGood[index]}
                                selected={selected[index]}
                                question={question}
                                onClick={done ? null : (mode) => handleAnswerClick(index, mode)} />
                        )
                    })
                }
            </div>
            <BottomBar
                mode={3}
                enabled={enabledCheck}
                text={done ? 'Finish' : 'Check'}
                onCheck={done ? () => onFinish() : () => onCheck()} />
        </div>
    )
}

export default StageDialog
